import { setLanguage } from "redux-i18n"

import {
  UPDATE_HEADER,
  LOADING,
  SEARCH_POLICY_BY_TAOBAO_ID_FAILED,
  SEARCH_POLICY_BY_TAOBAO_ID_SUCCESS,
  GET_USERS_BY_ID_SUCCESS,
  GET_USERS_BY_ID_FAILED,
} from '../../constants'

import { policyServices } from '../../services'

export const updateHeader = (header) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_HEADER, payload: header })
  }
}


export const updateLanguage = (lang) => {
  return (dispatch) => {
    dispatch(setLanguage(lang))
  }
}

export const updateLoadingStatus = (load) => {
  return (dispatch) => {
    dispatch({ type: LOADING, payload: load })
  }
}

export const searchPolicyByTaobaoId = (taobaoId: string) => {
  return (dispatch: Function) => {
    dispatch({ type: LOADING, payload: true })
    policyServices.getPolicyByTaobaoId(taobaoId).then(response => {
      dispatch({ type: LOADING, payload: false })
      if (response.ok) {
        return response.json()
      } else {
        throw 'Result not found'
      }
    })
    .then(result => {
      if (!result.result.policy) {
        throw 'Result not found'
      } else {
        if (!result.success) {
          throw result.error.message
        }
        dispatch({ type: SEARCH_POLICY_BY_TAOBAO_ID_SUCCESS, payload: result.result.policy.policyId })
        dispatch({ type: SEARCH_POLICY_BY_TAOBAO_ID_SUCCESS, payload: '' })
      }
    })
    .catch(error => {
      dispatch({ type: SEARCH_POLICY_BY_TAOBAO_ID_FAILED, payload: error })
      dispatch({ type: SEARCH_POLICY_BY_TAOBAO_ID_FAILED, payload: '' })
    })
  }
}

export const getUserNamesById = (ids) => {
  return (dispatch: Function) => {
    dispatch({ type: LOADING, payload: true })
    policyServices.getUserNamesById(ids).then(response => {
      dispatch({ type: LOADING, payload: false })
      if (response.ok) {
        return response.json()
      } else {
        throw 'Result not found'
      }
    })
    .then(data => {
      if (!data.success) {
        throw data.error.message
      }
      dispatch({ type: GET_USERS_BY_ID_SUCCESS, payload: data.result })
    })
    .catch(error => {
      dispatch({ type: GET_USERS_BY_ID_FAILED, payload: error })
      dispatch({ type: GET_USERS_BY_ID_FAILED, payload: '' })
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/App/actions.js